import { createSelector } from 'reselect';
import OperationalAnalysisDailyColumns from '../../containers/OperationalAnalysisDailyColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state.reporting.OPERATIONAL_ANALYSIS_DAILY.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.OPERATIONAL_ANALYSIS_DAILY.isLoading;

export const getData = ReportDefinitions.OPERATIONAL_ANALYSIS_DAILY.getDataFunction();

export const getColumns = createSelector(getData, OperationalAnalysisDailyColumns);
